import { render, staticRenderFns } from "./OmxRadioGroup.vue?vue&type=template&id=7d4abe01&scoped=true"
import script from "./OmxRadioGroup.vue?vue&type=script&lang=js"
export * from "./OmxRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./OmxRadioGroup.vue?vue&type=style&index=0&id=7d4abe01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4abe01",
  null
  
)

export default component.exports